import { render } from "./instrumentCard.vue?vue&type=template&id=50a0fa68&scoped=true"
import script from "./instrumentCard.vue?vue&type=script&lang=js"
export * from "./instrumentCard.vue?vue&type=script&lang=js"

import "./instrumentCard.vue?vue&type=style&index=0&id=50a0fa68&scoped=true&lang=css"

import exportComponent from "D:\\code\\vue\\gaoxinTech\\gaoxin_tech1\\gaoxintech\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50a0fa68"]])

export default __exports__